import { createApiUrl } from '../api'
import type { UserBidItemResponse } from '../../types/types.bids'

export class BidAPI {
  /**
   * Get user's live bids (bids on active auctions)
   */
  static async getUserLiveBids(accessToken: string): Promise<UserBidItemResponse[]> {
    const url = createApiUrl('/api/bids/user/live')

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    })

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Unauthorized')
      }
      throw new Error(`Failed to fetch live bids: ${response.statusText}`)
    }

    return response.json()
  }

  /**
   * Get user's won bids
   */
  static async getUserWonBids(accessToken: string): Promise<UserBidItemResponse[]> {
    const url = createApiUrl('/api/bids/user/won')

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    })

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Unauthorized')
      }
      throw new Error(`Failed to fetch won bids: ${response.statusText}`)
    }

    return response.json()
  }

  /**
   * Get user's closed/lost bids
   */
  static async getUserClosedBids(accessToken: string): Promise<UserBidItemResponse[]> {
    const url = createApiUrl('/api/bids/user/closed')

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    })

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Unauthorized')
      }
      throw new Error(`Failed to fetch closed bids: ${response.statusText}`)
    }

    return response.json()
  }
}
